import { Record, List } from 'immutable';
import { actionTypes } from './accessibility-notifications.actions';
import { v4 as uuidv4 } from 'uuid';


export const Notification = Record({
  id : '',
  message : '',
  alertLevel : '',
});

export const NotificationState = Record({
  notifications : List([])
});

export const accessibilityNotificationReducer = (state = new NotificationState(), action) => {

  switch (action.type) {
    case actionTypes.ADD:
    {
      const currentNotifications = state.get('notifications');
      return state.set('notifications', currentNotifications.push(new Notification({
        id : uuidv4(),
        message : action.message,
        alertLevel : action.alertLevel
      })));
    }
    case actionTypes.REMOVE:
    {
      const currentNotifications = state.get('notifications');
      return state.set('notifications', currentNotifications.filter(val => val.id !== action.id));
    }
    default:
      return state
  }
}
